<app-admin-form [title]="'Onderhoud Artikel Afbeeldingen'" [object]="itemImagesData">
  <table class="table table-striped small">
    <thead>
      <tr>
        <th>Artikel</th>
        <th>Omschrijving</th>
        <th>Afbeeldingen</th>
        <th class="text-end">Aktie</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of itemImagesData.Items">
        <td>{{item.ItemNumber}}</td>
        <td>{{item.ItemDescription}}</td>
        <td>
          <div class="image-thumbs-container">
            <div class="image-container" *ngFor="let image of item.Images">
              <img [src]="image.ImageUrl" class="img-fluid image-thumb" />
            </div>
          </div>
        </td>
        <td class="text-end">
          <div class="btn-group">
            <button class="btn btn-xs btn-outline-secondary" [routerLink]="['edit', item.InternalItemNumber]"><i
                class="fas fa-edit"></i> Wijzig</button>
            <button class="btn btn-xs btn-outline-secondary"
              (click)="delete(item)"><i class="fas fa-trash-alt"></i>
              Verwijder</button>
          </div>
        </td>
      </tr>
      <tr>
        <td class="text-end" colspan="7">

          <div class="btn-toolbar btn-toolbar-sm justify-content-end" role="toolbar">
            <div class="btn-group-sm me-2">
              <button class="btn btn-primary" [routerLink]="['new']"><i class="fa fa-plus"></i> Toevoegen</button>
            </div>
            <div class="input-group input-group-sm me-2 mb-3">
              <input type="text" [appFocus]="focusInput" [placeholder]="'filter'" [(ngModel)]="itemImagesData.Filter" (ngModelChange)="doFilter()" class="form-control">
              <button class="btn btn-outline-secondary" type="button" (click)="clearFilter($event)"><i class="fas fa-times"></i></button>
              <span class="input-group-text" id="inputGroup-sizing-sm">{{itemImagesData.RecordCount}}/{{itemImagesData.RecordCountUnfiltered}}</span>
            </div>

            <div class="input-group input-group-sm me-2 mb-3">
              <label class="input-group-text" for="inputGroupSelect01">Toon per</label>
              <select class="form-select" id="inputGroupSelect01" [(ngModel)]="itemImagesData.PageSize" (ngModelChange)="doFilter(true)">
                <option value="5" [selected]="itemImagesData.PageSize == 5">5</option>
                <option value="10" [selected]="itemImagesData.PageSize == 10">10</option>
                <option value="25" [selected]="itemImagesData.PageSize == 25">25</option>
                <option value="100" [selected]="itemImagesData.PageSize == 100">100</option>
              </select>
            </div>

            <nav *ngIf="mainService.getMathCeil(itemImagesData.RecordCount/itemImagesData.PageSize) > 1">
              <ul class="pagination pagination-sm">
                <li class="page-item" [ngClass]="{'disabled': itemImagesData.PageNumber==1}">
                  <a class="page-link" [routerLink]="['/admin/management/item-images']" [queryParams]="{pageNumber: itemImagesData.PageNumber - 1, filter: itemImagesData.Filter, pageSize: itemImagesData.PageSize}" aria-label="Previous">
                    <span aria-hidden="true">&laquo;</span>
                    <span class="sr-only">Previous</span>
                  </a>
                </li>
                <li class="page-item" [ngClass]="{'active': itemImagesData.PageNumber == 1}"><a class="page-link" [routerLink]="['/admin/management/item-images']" [queryParams]="{pageNumber: 1, filter: itemImagesData.Filter, pageSize: itemImagesData.PageSize}">1</a></li>
                <li *ngIf="itemImagesData.PageNumber > 2 && mainService.getMathCeil(itemImagesData.RecordCount/itemImagesData.PageSize) > 3" class="page-item disabled"><a class="page-link">...</a></li>
                <li *ngIf="itemImagesData.PageNumber != 1 && itemImagesData.PageNumber != mainService.getMathCeil(itemImagesData.RecordCount/itemImagesData.PageSize)" class="page-item active"><a class="page-link">{{itemImagesData.PageNumber}}</a></li>
                <li *ngIf="mainService.getMathCeil(itemImagesData.RecordCount/itemImagesData.PageSize) == 3 && itemImagesData.PageNumber != 2" class="page-item"><a class="page-link"  [routerLink]="['/admin/management/item-images']" [queryParams]="{pageNumber: 2, filter: itemImagesData.Filter, pageSize: itemImagesData.PageSize}">2</a></li>
                <li *ngIf="itemImagesData.PageNumber < mainService.getMathCeil(itemImagesData.RecordCount/itemImagesData.PageSize) - 1 && mainService.getMathCeil(itemImagesData.RecordCount/itemImagesData.PageSize) > 3" class="page-item disabled"><a class="page-link">...</a></li>
                <li class="page-item" [ngClass]="{'active': itemImagesData.PageNumber == mainService.getMathCeil(itemImagesData.RecordCount/itemImagesData.PageSize)}"><a class="page-link" [routerLink]="['/admin/management/item-images']" [queryParams]="{pageNumber: mainService.getMathCeil(itemImagesData.RecordCount/itemImagesData.PageSize), filter: itemImagesData.Filter, pageSize: itemImagesData.PageSize}">{{mainService.getMathCeil(itemImagesData.RecordCount/itemImagesData.PageSize)}}</a></li>
                <li class="page-item"
                  [ngClass]="{'disabled': itemImagesData.PageNumber == mainService.getMathCeil(itemImagesData.RecordCount/itemImagesData.PageSize)}">
                  <a class="page-link" [routerLink]="['/admin/management/item-images']" [queryParams]="{pageNumber: itemImagesData.PageNumber + 1, filter: itemImagesData.Filter, pageSize: itemImagesData.PageSize}" aria-label="Next">
                    <span aria-hidden="true">&raquo;</span>
                    <span class="sr-only">Next</span>
                  </a>
                </li>
              </ul>
            </nav>

          </div>

        </td>
      </tr>
    </tbody>
  </table>
</app-admin-form>